//#region src/types/webhook/types.ts
/**
* Types of Prismic Webhooks.
*
* @see More details: {@link https://prismic.io/docs/webhooks}
*/
const WebhookType = {
	APIUpdate: "api-update",
	TestTrigger: "test-trigger"
};
//#endregion
exports.WebhookType = WebhookType;

//# sourceMappingURL=types.cjs.map